/**
 * L2 — Formulários (“componentes de componentes”).
 * Cada item compõe papéis L1; variantes = layouts do mesmo formulário.
 */

const FORMS = [
  {
    id: 'form-actions',
    nome: 'Barra de ações',
    paraQue: 'Rodapé de formulário: confirmar, cancelar e opcionalmente excluir.',
    usa: ['btn-confirm', 'btn-cancel', 'btn-delete'],
    importName: 'FormActionsBar',
    usage: `<FormActionsBar
  appearance="right"
  onConfirm={salvar}
  onCancel={fechar}
  onDelete={podeExcluir ? excluir : undefined}
/>

{/* appearance: "right" | "split" | "stacked" */}`,
    variantes: [
      { id: 'A', nome: 'Ações à direita', mock: 'formActionsA' },
      { id: 'B', nome: 'Cancelar à esquerda / salvar à direita', mock: 'formActionsB' },
      { id: 'C', nome: 'Empilhado (mobile)', mock: 'formActionsC' },
    ],
  },
  {
    id: 'form-identity',
    nome: 'Identificação PF/PJ',
    paraQue: 'Bloco de nome, documento mascarado e e-mail.',
    usa: ['input-line', 'input-mask'],
    importName: 'FormIdentificacao',
    usage: `<FormIdentificacao
  appearance="stacked"
  value={pessoa}
  onChange={setPessoa}
/>

{/* appearance: "stacked" | "twoCol" | "compact" */}`,
    variantes: [
      { id: 'A', nome: 'Uma coluna', mock: 'formIdentityA' },
      { id: 'B', nome: 'Duas colunas', mock: 'formIdentityB' },
      { id: 'C', nome: 'Compacto (inline)', mock: 'formIdentityC' },
    ],
  },
  {
    id: 'form-address',
    nome: 'Bloco endereço',
    paraQue: 'CEP, logradouro, número, cidade e UF.',
    usa: ['input-line', 'input-mask', 'select'],
    importName: 'FormEndereco',
    usage: `<FormEndereco
  appearance="grid"
  value={endereco}
  onChange={setEndereco}
/>

{/* appearance: "grid" | "stacked" | "cepFirst" */}`,
    variantes: [
      { id: 'A', nome: 'Grade CEP + campos', mock: 'formAddressA' },
      { id: 'B', nome: 'Empilhado', mock: 'formAddressB' },
      { id: 'C', nome: 'CEP primeiro (busca)', mock: 'formAddressC' },
    ],
  },
  {
    id: 'form-filters',
    nome: 'Filtros de listagem',
    paraQue: 'Status, período e aplicar — composição pronta para listas.',
    usa: ['select', 'date', 'btn-confirm', 'filter'],
    importName: 'FormFiltrosLista',
    usage: `<FormFiltrosLista
  appearance="bar"
  value={filtros}
  onChange={setFiltros}
  onApply={buscar}
/>

{/* appearance: "bar" | "chips" | "drawer" */}`,
    variantes: [
      { id: 'A', nome: 'Barra horizontal', mock: 'formFiltersA' },
      { id: 'B', nome: 'Chips + editar', mock: 'formFiltersB' },
      { id: 'C', nome: 'Drawer de filtros', mock: 'formFiltersC' },
    ],
  },
  {
    id: 'form-modal-new',
    nome: 'Modal “Novo registro”',
    paraQue: 'Campos curtos + barra de ações dentro de modal.',
    usa: ['modal-form', 'input-line', 'select', 'btn-confirm', 'btn-cancel'],
    importName: 'FormModalNovo',
    usage: `<FormModalNovo
  open={open}
  appearance="md"
  onSubmit={criar}
  onCancel={fechar}
/>

{/* appearance: "sm" | "md" | "wide" */}`,
    variantes: [
      { id: 'A', nome: 'Compacto (1 campo)', mock: 'formModalNewA' },
      { id: 'B', nome: 'Médio (campos + select)', mock: 'formModalNewB' },
      { id: 'C', nome: 'Largo com abas', mock: 'formModalNewC' },
    ],
  },
  {
    id: 'form-approval',
    nome: 'Card de aprovação',
    paraQue: 'Resumo + motivo + aprovar/rejeitar.',
    usa: ['input-area', 'btn-confirm', 'btn-delete'],
    importName: 'FormAprovacao',
    usage: `<FormAprovacao
  appearance="withReason"
  item={pedido}
  onApprove={aprovar}
  onReject={rejeitar}
/>

{/* appearance: "actionsRight" | "fullWidth" | "withReason" */}`,
    variantes: [
      { id: 'A', nome: 'Ações à direita', mock: 'formApprovalA' },
      { id: 'B', nome: 'Ações full-width', mock: 'formApprovalB' },
      { id: 'C', nome: 'Com motivo', mock: 'formApprovalC' },
    ],
  },
  {
    id: 'form-upload',
    nome: 'Upload com lista',
    paraQue: 'Anexar arquivos e listar o que já está no registro.',
    usa: ['upload', 'btn-cancel'],
    importName: 'FormAnexos',
    usage: `<FormAnexos
  appearance="buttonList"
  files={anexos}
  onChange={setAnexos}
/>

{/* appearance: "buttonList" | "dropzone" | "thumbs" */}`,
    variantes: [
      { id: 'A', nome: 'Botão + lista', mock: 'formUploadA' },
      { id: 'B', nome: 'Zona drag-and-drop', mock: 'formUploadB' },
      { id: 'C', nome: 'Grade de miniaturas', mock: 'formUploadC' },
    ],
  },
  {
    id: 'form-multisection',
    nome: 'Formulário wizard',
    paraQue:
      'Formulário que segue uma ordem: a etapa seguinte só abre depois da anterior. Não é accordion nem abas soltas.',
    usa: ['form-layout', 'input-line', 'input-area', 'upload', 'stepper'],
    importName: 'FormWizard',
    usage: `<FormWizard
  appearance="steps"
  value={dados}
  onChange={setDados}
/>

{/* appearance: "steps" — a ordem das etapas é obrigatória */}`,
    variantes: [
      { id: 'A', nome: 'Etapa 1 de 3', mock: 'formMultiA' },
      { id: 'B', nome: 'Não pula etapa', mock: 'formMultiB' },
      { id: 'C', nome: 'Passos numerados', mock: 'formMultiC' },
    ],
  },
]

export default FORMS
